export const colors = {
  primaryDarkBlue: "#333375",
  linearGradient:
    "linear-gradient(180deg, #D90D0D -6.54%, #982440 25.63%, #64376B 51.34%, #6C3175 58.48%, #A0223B 106.54%)",
};
